var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(("opacity: " + _vm.opacity)),attrs:{"loading":"lazy","src":require("./../../../public/assets/images/general/arrows.svg"),"alt":"arrows"}})}
var staticRenderFns = []

export { render, staticRenderFns }